// src/pages/projects/hooks/useProjectBudget.js
import { useState } from 'react';
import useProjectStore from '../../../stores/projectStore';
import { DEFAULT_TRANSACTION } from '../../../constants/budgetConstants';

/**
 * Custom hook to manage project budget transactions
 * @param {string} projectId - Project ID
 * @returns {Object} Budget management functions and state
 */
const useProjectBudget = (projectId) => {
  // Transaction state
  const [transaction, setTransaction] = useState({ ...DEFAULT_TRANSACTION });
  const [isAddTransactionOpen, setIsAddTransactionOpen] = useState(false);
  
  // Get project store functions
  const { addBudgetTransaction, deleteBudgetTransaction } = useProjectStore();
  
  // Handle add transaction
  const handleAddTransaction = async () => {
    if (!transaction.amount || !transaction.description) return;
    
    try {
      await addBudgetTransaction(projectId, {
        ...transaction,
        amount: parseFloat(transaction.amount)
      });
      
      // Reset form and close dialog
      setTransaction({ ...DEFAULT_TRANSACTION });
      setIsAddTransactionOpen(false);
    } catch (err) {
      console.log('Failed to add transaction:', err);
    }
  };
  
  // Handle delete transaction
  const handleDeleteTransaction = async (transactionToDelete, confirmDelete) => {
    const confirmed = await confirmDelete({
      title: 'Delete Transaction',
      content: `Are you sure you want to delete this ${transactionToDelete.type}? This action cannot be undone.`,
      confirmText: 'Delete',
      cancelText: 'Cancel'
    });
    
    if (confirmed) {
      try {
        await deleteBudgetTransaction(projectId, transactionToDelete._id);
      } catch (err) {
        console.log('Failed to delete transaction:', err);
      }
    }
  };
  
  return {
    transaction,
    setTransaction,
    isAddTransactionOpen,
    setIsAddTransactionOpen,
    handleAddTransaction,
    handleDeleteTransaction
  };
};

export default useProjectBudget;